import { Facebook, Instagram, Linkedin } from "lucide-react";
import { Link } from "react-router-dom";
import acLogo from "@/assets/ac-logo.webp";

const Footer = () => {
  return (
    <footer className="border-t border-slate-900 bg-slate-950 pt-16 pb-8">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col items-center text-center">
        
        {/* Logo */}
        <Link to="/" className="mb-6 inline-block transition-transform hover:scale-105">
          <img src={acLogo} alt="ATC Logo" className="h-24 w-24 object-contain mx-auto" />
        </Link>

        {/* Description */}
        <h4 className="max-w-3xl text-lg md:text-xl font-medium text-slate-200 mb-8 leading-relaxed">
          Automated Transaction Coordinator (ATC) is a comprehensive full service Transaction Coordinating service provider, designed to revolutionize your real estate transaction process by significantly saving you time, reducing costs, and alleviating stress.
        </h4>

        {/* Social Icons */}
        <div className="flex items-center gap-6 mb-12">
          <a 
            href="#" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="p-3 rounded-full bg-slate-800 text-slate-400 hover:bg-primary hover:text-primary-foreground transition-all duration-300 hover:scale-110"
          >
            <span className="sr-only">Facebook</span>
            <Facebook className="h-5 w-5" />
          </a>
          <a 
            href="#" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="p-3 rounded-full bg-slate-800 text-slate-400 hover:bg-primary hover:text-primary-foreground transition-all duration-300 hover:scale-110"
          >
            <span className="sr-only">Instagram</span>
            <Instagram className="h-5 w-5" />
          </a>
          <a 
            href="#" 
            target="_blank" 
            rel="noopener noreferrer" 
            className="p-3 rounded-full bg-slate-800 text-slate-400 hover:bg-primary hover:text-primary-foreground transition-all duration-300 hover:scale-110"
          >
            <span className="sr-only">LinkedIn</span>
            <Linkedin className="h-5 w-5" />
          </a>
        </div>

        {/* Divider */}
        <div className="w-full h-px bg-slate-800 mb-8 max-w-5xl mx-auto"></div>

        {/* Copyright & Links */}
        <div className="text-sm text-slate-400 flex flex-col md:flex-row items-center justify-center gap-2 md:gap-3">
          <p>Copyright © {new Date().getFullYear()} Automated Transaction Coordinator Inc. All Rights Reserved</p>
          <span className="hidden md:inline text-slate-700">|</span>
          <div className="flex gap-2">
            <a 
              href="https://useatc.com/privacy-policy/" 
              className="hover:text-primary transition-colors hover:underline"
            >
              Privacy Policy
            </a>
            <span>&amp;</span>
            <a 
              href="https://useatc.com/terms-and-conditions/" 
              className="hover:text-primary transition-colors hover:underline"
            >
              Terms and Conditions
            </a>
          </div>
        </div>
        
      </div>
    </footer>
  );
};

export default Footer;